export default "__VITE_ASSET__wMiB_NWh__"